import { c as _c } from "react/compiler-runtime";
import { JSX } from "react";
type ProfileMenuItemType = {
  label: string;
  subTitle?: string;
  icon: JSX.Element;
  value?: string | JSX.Element;
  onClick?: () => void;
};
export function ProfileMenuItem(t0) {
  const $ = _c(16);
  const {
    icon,
    label,
    subTitle,
    value,
    onClick
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <div className="text-on-surface-medium-emphasis text-headline-5">{icon}</div>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subTitle) {
    t2 = subTitle && <span className="text-extra-caption text-on-surface-medium-emphasis py-1">{subTitle}</span>;
    $[2] = subTitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== label || $[5] !== t2) {
    t3 = <span className="text-subtitle-1 text-on-surface-high-emphasis flex flex-col">{label}{t2}</span>;
    $[4] = label;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== value) {
    t4 = value && <span className="text-caption text-on-surface-high-emphasis mr-auto">{value}</span>;
    $[7] = value;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t4) {
    t5 = <div className="border-outline-thin flex min-h-[56px] items-center gap-4 border-t py-2">{t1}{t3}{t4}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== onClick || $[14] !== t5) {
    t6 = <div className="hover:bg-outline-thin w-full cursor-pointer px-6 transition-colors duration-200" onClick={onClick} role="menuitem">{t5}</div>;
    $[13] = onClick;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}